import etsFormBackground from 'gcs-common/img/ets-form-background.png';

const TicketDragArea = () => {
  return (
    <div className="m-4 flex h-full items-center justify-center border-2 border-neutral-7 border-dashed">
      <div className="flex flex-col items-center text-center">
        <img src={etsFormBackground} alt="Bild" className="mb-4" />
        <p className="font-medium text-xl">Bilder hier ablegen</p>
      </div>
    </div>
  );
};

export default TicketDragArea;
